import styled from 'styled-components'

export const LoginPageMobileContainer = styled('div')`
  height: 100vh;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
`
